<dff-side [observable]="vm$">
  @if (vm$ | async; as vm) {
    <dff-side-titel>{{ vm.sideTitel }}</dff-side-titel>
    <dff-info>Målernr. {{ vm.formGroup.get("aflaesning").value.maalerNr.aktuel }}</dff-info>
    @if (formGroupErrors.length > 0) {
      <fieldset class="errors-field">
        <legend>Der er fejl i formularen</legend>
        <ul>
          @for (error of formGroupErrors; track error) {
            <li>
              <button
                [attr.id]="error.inputId + '-error-button'"
                (click)="navigationToError(error.inputId)"
                class="errors-field__button"
                role="button"
                type="button"
                [attr.aria-label]="'Naviger til ' + error.label + ' feltet'"
                >
                {{ error.label }} {{ error.error }}
              </button>
            </li>
          }
        </ul>
      </fieldset>
    }
    @if (vm.formGroup && step === 0) {
      <mat-vertical-stepper #stepper [linear]="true" class="dff-style mat-elevation-z2">
        <ng-template matStepperIcon="edit"><mat-icon svgIcon="check"></mat-icon></ng-template>
        <mat-step [completed]="isValid(vm.formGroup, 'dato')">
          <ng-template matStepLabel>
            <h2 class="panel-header">Indtast dato for aflæsning</h2>
          </ng-template>
          <dff-date-field
            data-testid="KAK"
            [formControl]="vm.formGroup.get('dato')"
            [max]="minDate"
            [required]="true"
            placeholder="Dato for aflæsning"
          ></dff-date-field>
          <button
            mat-flat-button
            color="primary"
            aria-label="Fortsæt til Indtast aflæsninger"
            (click)="onNext(vm.formGroup.get('dato'))"
            role="button"
            type="button"
            >
            Næste
          </button>
        </mat-step>
        <mat-step [completed]="isValid(vm.formGroup, 'dato', 'aflaesning')">
          <ng-template matStepLabel>
            <h2 class="panel-header">Indtast aflæsninger <span class="sr-only">siden sidst fakturerede aflæsning</span></h2>
          </ng-template>
          <maaler-aflaesning [formGroup]="vm.formGroup.get('aflaesning')"></maaler-aflaesning>
          <small aria-hidden="true"><sup>*</sup>sidst fakturerede aflæsning</small>
          <error [error]="gemAflaesningError"></error>
          <dff-button-panel>
            <dff-spinner-button [spinning]="gemmerAflaesning" [buttonType]="'submit'" (click)="onGemAflaesning(vm.formGroup)"
              >Udfør</dff-spinner-button
              >
            </dff-button-panel>
          </mat-step>
        </mat-vertical-stepper>
      }
      @if (step === 1) {
        <dff-info type="success"> Tak for din aflæsning </dff-info>
        <panel titel="Kvittering">
          <maaler-aflaesning-kvittering [formGroup]="vm.formGroup"></maaler-aflaesning-kvittering>
        </panel>
        <panel titel="Ønsker du din kvittering tilsendt?">
          <dff-email-field [formControl]="vm.formGroup.get('email')" placeholder="E-mail"></dff-email-field>
          <dff-spinner-button
            [disabled]="!isValidEmail(vm.formGroup.get('email'))"
            [spinning]="senderKvittering"
            (click)="onSendKvittering(vm.formGroup)"
            >Send kvittering</dff-spinner-button
            >
          </panel>
          <a href="#/mit-forbrug">Tilbage til Mit forbrug</a>
        }
        @if (step === 2) {
          <dff-info type="success">
            Du vil i løbet af få minutter modtage en kvittering på e-mail: {{ vm.formGroup.get("email").value }}
          </dff-info>
          <panel titel="Kvittering">
            <maaler-aflaesning-kvittering [formGroup]="vm.formGroup"></maaler-aflaesning-kvittering>
          </panel>
          <a href="#/mit-forbrug">Tilbage til Mit forbrug</a>
        }
      }
    </dff-side>
